/**
 * "Nd ago" style age of a timestamp, as the procedure lists and the Overall
 * Status board show since-started.
 *
 * Past 30 days it switches to a plain date: "143d ago" is harder to place than
 * the date itself. `now` is injectable for tests.
 */
export function timeAgo(iso: string | null, now: number = Date.now()): string {
  if (!iso) return '—'
  const diff = now - new Date(iso).getTime()
  const mins = Math.round(diff / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hrs = Math.round(mins / 60)
  if (hrs < 24) return `${hrs}h ago`
  const days = Math.round(hrs / 24)
  if (days < 30) return `${days}d ago`
  return new Date(iso).toLocaleDateString()
}
